export const contractVehicles = [
  'Open Market',
  'GSA',
  'Risk Buy',
  '2GIT',
  'CIO-CS',
  'County Sierra',
  'DLA',
  'DOL BPA',
  'ESNET',
  'FBO',
  'FirstSource II SB',
  'ICPT',
  'ICPT UCOR',
  'SeaPort',
  'Unison (formerly FedBid)',
  'SEWP V',
  'SEWP V DHA Citrix',
  'SEWP V DHA CommVault',
  'SEWP V DHA Dell EUD',
  'SEWP V DHA Juniper',
  'SEWP V DHA Palo Alto',
  'SEWP V DHA Printer',
  'SEWP V DHA SolarWinds',
  'SEWP V GSS',
  'SEWP V NASA Covered Articles',
]

export const contractNumbers = [
  'NONE',
  'GS-35F-0002V',
  'N64267-15-A-0104',
  'HSHQDC-13-D-00015',
  'HHSN316201500029W',
  'SAQMMA-16-A-0257',
  'HSHQDC-12-D-00017',
  'HDQMWR-16-D-0013',
  'HI NASPO_NVP #AR3227',
  'GS-06F-1027Z',
  'GSA_1605DC-17-A-0009',
  'SPE4A6-16-D-5326',
  'NNG15SD41B',
  'GSA_HC1028-18-A-0006',
  'GSA_47QTCA20A004P',
  'H98230-20-D-0012',
  'ESNET_1000001925',
  'GSA_47QTCA21A001G',
  'GSA_1605TB-22-A-0001',
  'ICPT_ORNL-2021-1001',
  'NNG15SC86B',
  'GSA_123144-25-A-0007',
  'GSA_123144-25-A-0003',
  'GSA_86615424A00001',
  'GSA_86615424A00004',
]

export const quoteStatuses = ['Obsolete', 'Draft', 'Approved', 'Sent to Customer', 'Closed Lost', 'Closed Won']

export const govPayTerms = [
  'Prepaid',
  'Credit Card',
  'Due on Receipt',
  'Net 15',
  'Net 30',
  'Net 45',
  'Net 60',
  'AOC 30',
]

export const salesforceStages = [
  '1. Prospect',
  '2. Qualify',
  '3. Evaluate',
  '4. Proposal',
  '4b. Commitment',
  '5. Closed Won',
  '6. Closed Lost',
  '7. Duplicate',
  '8. No Bid',
]

export const salesforceForecastCategories = ['Pipeline', 'Best Case', 'Commit', 'Omitted', 'Closed']

export const coreCompetencies = ['Data Center', 'Networking', 'Security', 'Services', 'Workforce Enablement']

export const setAsides = [
  'Full & Open',
  'SB (Small Business)',
  'HUBZone (Historically Underutilized Business Zone)',
  'SDVOSB (Service-Disabled Veteran-Owned Small Business)',
  'WOSB (Woman-Owned Small Business)',
  '8(a) Business Development Program',
  'SDB (Small Disadvantaged Business)',
]

export const manufacturerProviders = [
  'IMPRES Technology Solutions, Inc.',
  '/n Software Inc.',
  '@Xi Computer Corp.',
  '1 Beyond, Inc.',
  '10GTEK',
  '10ZiG Technology',
  '1800ceiling It International, Inc.',
  '1Password',
  '3D Systems, Inc.',
  '3Dconnexion, Inc.',
  '3DZWMAN',
  '3M',
  '4 Star Technologies, Inc.',
  '4K Solutions, LLC',
  '4XBOLT',
  '4XEM Corp.',
  '90meter, Inc.',
  'A. Rifkin Co.',
  'A10 Networks, Inc.',
  'A2B Tracking Solutions Inc.',
  'AAXA Technologies Inc',
  'AB Chance',
  'AB Powers',
  'Abaco Systems Inc',
  'ABB Group',
  'Aberdeen, LLC',
  'Ability one',
  'AbilityOne',
  'ABP',
  'Absolute Software Corp.',
  'Abt Electronics Inc',
  'AC Infinity Inc.',
  'Accellion, Inc.',
  'AccelTex Solutions',
  'Access Communications Group',
  'AccessData Group, LLC',
  'ACCO Brands Corp.',
  'Accton Technology Corp.',
  'Accu-Tech Corp.',
  'Ace Electronics, Inc.',
  'Ace Technology Partners, LLC',
  'ACE Warehouse Management',
  'Acer Inc.',
  'ACG Systems Inc',
  'Acklands-Grainger Inc',
  'Acopian Technical Co.',
  'Acorn Growth Companies LLC',
  'Acquia, Inc.',
  'Acroamatcis Telemetry Systems',
  'Acronis Inc.',
  'Action Battery Wholesalers',
  'Actiontec Electronics, Inc.',
  'Acudata Inc',
  'Acumentrics Corp.',
  'AcuRite',
  'Acuteksystems LLC',
  'Ad Astra',
  'Adafruit Industries, LLC',
  'Adaptavist Group LTD',
  'ADATA Technology Co., Ltd',
  'Adder Technology Ltd',
  'Addon Technology. Ltd',
  'Addonics Technologies Inc.',
  'Addteq Inc',
  'Adesso Inc.',
  'ADIMLab',
  'Admiral Overseas Corp.',
  'Adobe Systems, Inc.',
  'Adorama Camera, Inc',
  'Advanced Card Systems Holdings Ltd',
  'Advanced Communications & Electronics',
  'Advanced Computer & Network Corp.',
  'Advanced Energy Industries, Inc',
  'Advanced Media Technologies',
  'Advanced Micro Devices, Inc.',
  'Advanced Microwave Components',
  'Advanced Mounting and Design Inc.',
  'Advanced Plastics',
  'Advantech Co., Ltd',
  'AeroBase Group',
  'Aeronix, Inc',
  'Aerotech',
  'Aevoe Corp.',
  'Afinia Einstar',
  'AFL Global',
  'Agile Communications, Inc.',
  'Agilent Technologies, Inc.',
  'AgileTek',
  'Ahlberg Cameras',
  'Airspan Networks',
  'AirTrack',
  'AJ Power Supply Inc',
  'AJ Tek Corporation',
  'AJA Video Systems Inc.',
  'Akamai Technologies, Inc.',
  'AKooba, Inc.',
  'Alexander Machine & Tool Co., Inc.',
  'ALFA Network Inc.',
  'Alfresco Software, Inc.',
  'AlienVault LLC',
  'Alizon Tech Corp LTD',
  'All Data Resource',
  'Allcases, Reekstin & Associates, Inc.',
  'Allen Tel Products, Inc.',
  'ALLHDD',
  'Allied Electronics, Inc.',
  'Allied Moulded Products, Inc.',
  'Allied Telesis Inc',
  'Alloy coating Supply',
  'Alloy Software, Inc.',
  'Allround Automations',
  'Alpha Group',
  'Alpha-American Programmable Signs',
  'Alphabet Inc',
  'ALT Systems',
  'Alta Data Technologies LLC',
  'Altech Corp',
  'Altered Carbon LTD',
  'Altex Electronics, Ltd',
  'Altova GmbH',
  'Altronix Corp.',
  'Altus, Inc.',
  'Aluratek, Inc.',
  'AMAG Technology, Inc.',
  'Amazon.com, Inc.',
  'Ambir Technology Inc.',
  'American Electrical, Inc.',
  'American Labelmark Company',
  'AMERICAN SYSTEMS',
  'American Wordata, Inc.',
  'American-Milspec, LLC',
  'Ameripack Inc.',
  'Ametek, Inc.',
  'AMOLEN',
  'Amphenol Corp.',
  'Anacapa Micro Products, Inc.',
  'Analog Devices, Inc.',
  'Anchor Audio, Inc.',
  'Anchor Enterprises',
  'Anchore, Inc',
  'Andrea Electronics Corp.',
  'Anduril Industries, Inc',
  'Ansys Inc',
  'Antenna Research Associates, Inc.',
  'ANTERK',
  'ANTs Software Inc.',
  'Antylia Scientific',
  'AnythingIT Corp.',
  'AnyTone',
  'Apacer Technology Inc.',
  'Apantac LLC',
  'APconnections, Inc.',
  'Apex Tool Group, LLC',
  'Apogee Labs, Inc.',
  'Apollo Precision Tools',
  'AppDynamics, Inc.',
  'Appfire Technologies, LLC',
  'Appian Corp.',
  'Apple Computer, Inc.',
  'Applied Computer Systems, Inc.',
  'Applied Flow Technology',
  'Applied Technology Group',
  'Apposite Technology, Inc.',
  'Appspace Inc.',
  'Apricorn Inc.',
  'AR Modular RF',
  'Arbitech LLC',
  'ArcanaNetworks Inc.',
  'Archer Technologies LLC',
  'Archon Secure',
  'Archon Systems Inc.',
  'Archtech Electronics Corp.',
  'Arclyte Technologies, Inc.',
  'Arcserve, LLC',
  'Ardalyst Federal, LLC',
  'Arista Networks, Inc.',
  'Arlington Industries, Inc.',
  'Arm and hammer',
  'Armis Inc',
  'ARRIS Group, Inc.',
  'Arrow Electronics, Inc.',
  'Artec Group',
  'Artel Video Systems',
  'Artesyn Embedded Technologies Inc',
  'Articulate Global, Inc.',
  'ASAP Semiconductor LLC',
  'ASL Inc.',
  'Aspen Fasteners',
  'Aspen Systems, Inc.',
  'AST Group Holdings Ltd.',
  'Astro Tool Corp',
  'Astron Corporation',
  'ASUSTeK Computer Inc.',
  'AT&T Corporation',
  'Atcom Services, Inc.',
  'ATEN International Co., Ltd.',
  'Atkore International Inc.',
  'Atlantis Computing, Inc.',
  'Atlas Business Solutions, Inc.',
  'Atlas Phones',
  'Atlassian Software Systems Pty Ltd.',
  'Atlona Inc.',
  'Atomos',
  'ATOP Technologies, Inc.',
  'ATSI Holdings, Inc.',
  'Attero Tech',
  'Attivo Networks, Inc.',
  'ATTO Technology, Inc.',
  'Audinate Pty Ltd',
  'Audio Visual Furniture International Inc.',
  'Audio-Technica Corp.',
  'Audio-Visual Direct',
  'Audix',
  'AUGUSTA Technologie AG',
  'Aukey International Ltd',
  'Aurora Multimedia Corp.',
  'Austin Hughes Electronics Ltd',
  'Autodesk Inc.',
  'Automation Innovations LLC',
  'AutomationDirect.com',
  'Avant Technology, Inc.',
  'Avaya, Inc.',
  'AvePoint, Inc.',
  'AVer Information Inc.',
  'AVerMedia Inc.',
  'Avery Dennison Corp.',
  'AVF Group',
  'AVI Systems, Inc.',
  'AVI-SPL, Inc.',
  'Avnet, Inc.',
  'Avocor LTD',
  'AVProGlobal Holdings',
  'AVTECH Software, Inc.',
  'AVTEQ, Inc.',
  'Aware Innovations, LLC',
  'Axiom Upgrades',
  'Axis Communications AB',
  'Axway Inc.',
  'Ayeway',
  'B&K Precision Corp',
  'B2X Global',
  'Bacula Systems SA',
  'BAE Systems plc',
  'Baldwin Technologies, Inc.',
  'Ballard Technology, Inc.',
  'Baltic Networks',
  'Bambu Lab',
  'Baoding Yituzhe Bags Manufacturing Co., Ltd',
  'Barco N.V.',
  'Barcodes, Inc.',
  'Barker & Williamson',
  'Barracuda Networks, Inc.',
  'BatchPatch',
  'Battery Technology, Inc.',
  'BatterySpace',
  'Bay Technical Associates',
  'Bel Fuse, Inc.',
  'Belden Inc',
  'Belkin International, Inc.',
  'Benchmade Inc',
  'BenQ Corp.',
  'Best Buy',
  'Best Practical Solutions, LLC',
  'BeyondTrust Software, Inc.',
  'BFRIENDit',
  'BHPHOTOVIDEO.COM',
  'Biamp Corp.',
  'Bifrost',
  'Bike Track',
  'BIO-key International Inc.',
  'Bio-Medical Instruments',
  'Biometric Information Management',
  'Bird Technologies Group, Inc.',
  'BirdDog',
  'Bisco industries',
  'Biscom, Inc.',
  'BitDefender SRL',
  'Bittree, Inc.',
  'Black Box Corp.',
  'Black Deer Construction',
  'BlackBag Technologies, Inc.',
  'Blackberry LTD',
  'Blackmagic Design Pty. Ltd.',
  'blackned GMBH',
  'Blackwood Associates, Inc.',
  'Blancco Oy Ltd',
  'Blue Card',
  'Blue Prism Software Inc.',
  'Blue Robotics Inc.',
  'BlueCat Networks, Inc.',
  'BlueStar Inc.',
  'Bluetti',
  'BMC Software, Inc.',
  'Bogen Communications, Inc.',
  'Bondhus',
  'Boorum & Pease',
  'Booz Allen Hamilton Inc',
  'Bosch Group',
  'Bose Corp.',
  'Bottom Line Telecommunications, Inc.',
  'Bowers & Wilkins',
  'Box, Inc.',
  'Brady Corporation Ltd',
  'Brandywine',
  'Bravas LLC',
  'Brave Federal',
  'Bravium Consulting LLC',
  'Braxton-Grant Technologies, Inc.',
  'Brekeke Software, Inc.',
  'Bren-Tronics Inc.',
  'Bretford, Inc.',
  'BRG Precision Products, Inc.',
  'BrightSign, LLC',
  'Broadcom LTD',
  'Brocade Communications Systems',
  'Brooks Power Systems',
  'BrosTrend Technology LLC',
  'Brother Industries, LTD',
  'Brydge',
  'BTX Technologies, Inc.',
  'Buckingham Manufacturing',
  'Bud Griffin and Associates',
  'Buffalo Technology, Inc.',
  'BulkDevices',
  'Bush Business Furniture',
  'BXQINLENX',
  'C.E. Niehoff & Co.',
  'CA Technologies, Inc.',
  'Cable & Wireless Technologies, Inc.',
  'Cable Exchange',
  'Cable Manufacturing, Inc.',
  'Cable Matters Inc.',
  'Cable Ties And More Inc.',
  'CableCreation',
  'CableOrganizer.com, LLC',
  'Cables & Connectors, Inc.',
  'Cables Plus, LLC',
  'cablesANDkits',
  'CableWholesale.com, Inc.',
  'CACI International Inc.',
  'CalDigit Inc.',
  'California Peripherals & Components Inc.',
  'Cambium Networks, LTD',
  'Cambridge Computer Services, Inc.',
  'Cana Kit Corp',
  'Cana Kit Corp.',
  'Canless Air System',
  'Canoga Perkins Corp.',
  'Canon, Inc.',
  'Canonical Ltd',
  'Capital Shredder Corp.',
  'Caputron',
  'Carahsoft',
  'Carbonite, Inc.',
  'Cardinal Bag Supplies',
  'Carlisle Companies Inc.',
  'Case Logic, Inc.',
  'CaseTech, Inc.',
  'Cavium, Inc.',
  'CBA Inc.',
  'CCI Systems',
  'CCTV Camera Pros, LLC',
  'CDO Technologies, Inc.',
  'CDW Government, LLC',
  'Centon Electronics, Inc.',
  'CentricRF',
  'Centrify Corp.',
  'Centurion Medical Products Corp',
  'Ceptics',
  'Cerner Corp.',
  'Channellock, Inc.',
  'ChargeTech',
  'Charon Technologies, LLC',
  'Chase Corporation',
  'Chatsworth Products, Inc.',
  'CHE Consulting, Inc',
  'Checkpoint Software Technologies Ltd.',
  'Chef Software, Inc',
  'Chelsio Communications, Inc.',
  'Chenbro Micom Co., Ltd.',
  'Cherry GmbH',
  'Chesapeake Systems',
  'Chicony',
  'Chief Technologies LLC',
  'China Huaxin Post and Telecom Technologies Co., Ltd',
  'Christie Digital Systems, Inc.',
  'Ciena Corp.',
  'Cincinnati Bell, Inc.',
  'CineMassive Displays',
  'CIS Secure Computing, Inc.',
  'Cisco Systems Inc',
  'Citrix Systems, Inc.',
  'ClarkDietrich',
  'Clary Business Machines',
  'Clary Icon Pvt Ltd.',
  'ClearCube Technology, Inc.',
  'ClearOne, Inc.',
  'ClearShark LLC',
  'Cleary Zimmermann',
  'Climb Channel Solutions',
  'Clint Precision Manufacturing',
  'Clockaudio LTD',
  'CloudBees, Inc.',
  'Cloudera, Inc.',
  'CloudFlare',
  'Cloudian Inc.',
  'CMC Magnetics Corp',
  'CNS Vital Signs',
  'Coastline Networks, Inc.',
  'Cobham Antenna Systems',
  'Codeorigin, LLC',
  'Codi Inc.',
  'Cofense Inc',
  'Cognian',
  'Cognitec Systems GmbH',
  'Cohesity Inc',
  'Coleman Cable, Inc.',
  'Colorado State Electrical and Security',
  'Colossal Contracting LLC',
  'COMECASE',
  'CommScope Holding Company, Inc.',
  'Communication Devices, Inc.',
  'Communications & Power Industries LLC',
  'Communications International',
  'CommVault Systems, Inc.',
  'Comnet Communication Networks',
  'ComponentSource, Inc.',
  'COMPRION GmbH',
  'Comprod Communications Ltd',
  'Compu-Gen Technologies, Inc.',
  'Compulocks Brands Inc.',
  'Compunetix, Inc.',
  'Computer Cable Store',
  'Comrod Communications ASA',
  'Comtech Systems, Inc.',
  'Comtop Connectivity Solutions Inc.',
  'Comtrol Corp.',
  'Condor',
  'Condusiv Technologies Corp.',
  'Conexus, Inc.',
  'Confluent, Inc',
  'Connect Tech Inc.',
  'Connection',
  'ConnectPRO',
  'Connectrac',
  'Constant Technologies Inc',
  'CONTA-CLIP Inc',
  'Contemporary Research Corp.',
  'Conterra',
  'Continental Optronics',
  'Contour Design, Inc.',
  'Convergint Technologies LLC',
  'Cool Tech PC Inc.',
  'Cooler Master Co., Ltd.',
  'Coolerguys',
  'Copado Solutions S.L.',
  'Coraid Inc.',
  'CoreKinect',
  'Corel Corp.',
  'CorelDRAW',
  'Corelight Inc',
  'Coretronic Corp.',
  'Corner Bowl Software Corporation',
  'CorNic Technologies',
  'Corning Inc.',
  'Corona Technical Services',
  'Corsair Components, Inc',
  'Corsair Memory Inc.',
  'Covid Inc.',
  'CP Technologies',
  'CPU Medics',
  'Crackle Holdings, L.P',
  'CradlePoint, Inc.',
  'Craftsman',
  'Cranel, Inc.',
  'Creation 4Mation, Inc',
  'Creative Mounting Solutions',
  'Creative Technology Ltd.',
  'Crescent',
  'Crescent Electric Supply Co',
  'Crest Healthcare Supply',
  'Crestron Electronics, Inc.',
  'CRU Data Security Group, LLC',
  'Crucial',
  'Cruiser',
  'Crutchfield Corporation',
  'CRYE PRECISION',
  'Crystal Group, Inc.',
  'CrystalGraphics, Inc.',
  'CSM GmbH',
  'CSP Inc.',
  'CSYANXING',
  'CTERA Networks LTD',
  'CTG Federal, LLC',
  'CTI Federal Inc.',
  'Cube Solutions',
  'Cubic Corp',
  'Cumulus Networks Inc',
  'Curtis',
  'Curtiss-Wright Corporation',
  'Curvature LLC',
  'Cxtec',
  'Cyber Acoustics, LLC',
  'Cyber Power Systems, Inc.',
  'Cyber Ranges, Ltd.',
  'CyberArk Software, Ltd',
  'Cybernet Manufacturing, Inc.',
  'Cybernetics',
  'CyberView',
  'Cytec Corp.',
  'D&H Distributing',
  'D2G Group LLC',
  'Dahle North America, Inc.',
  'Dakota Lithium',
  'Dana Innovations',
  'Daniels Manufacturing Corp.',
  'DaqScribe Solutions, LLC',
  'Dassault Systemes SE',
  'Data Comm for Business Inc.',
  'Data in Science Technologies',
  'Data Locker Inc.',
  'DataCenter Resources',
  'Datacolor AG',
  'Datacom Systems Inc.',
  'DataComm Cables, Inc.',
  'DataDirect Networks, Inc.',
  'Datadobi',
  'Datadog, Inc.',
  'Datalogic, S.p.A.',
  'DCX-CHOL Enterprises, Inc.',
  'DDB Unlimited inc.',
  'Decimator Design PTY LTD',
  'Defender.com',
  'DEI Holdings, Inc.',
  'Delcom Products Inc.',
  'Delinea Inc.',
  'Dell, Inc.',
  'Delta Group',
  'Delta Information Systems, inc.',
  'Delta Telemetry Systems',
  'Deltek Systems Inc.',
  'Demant A/S',
  'Deployable Systems, Inc',
  'Depot International, LLC',
  'Dermody Associates, Inc.',
  'Design Science, Inc.',
  'Device42 Inc',
  'Deviniti Sp. z o.o.',
  'Devo Technology Inc.',
  'DEWALT Industrial Tool Co.',
  'Dexpt',
  'Dexxxon Digital Storage Inc',
  'DGZZI',
  'Diablo Tools',
  'Diamond Multimedia, Inc.',
  'Digi International Inc.',
  'Digicert Inc.',
  'DigiGear, Inc.',
  'Digi-Key Electronics',
  'Digital Barriers plc',
  'Digital Combustion, Inc.',
  'Digital Data Communications GmbH',
  'Digital Display Systems, Inc.',
  'Digital Forecast',
  'Digital Guardian',
  'Digital Intelligence, Inc',
  'Digital Loggers, Inc.',
  'Digital Monitoring Products',
  'Digital Projection, Inc.',
  'Digital Tigers, Inc.',
  'DigitalBuyer.com',
  'DigitalCM',
  'Digi-trax Corp.',
  'DiscTech LLC',
  'DiskInternals Ltd',
  'Diving Unlimited',
  'D-Line LTD',
  'D-Link Systems, Inc.',
  'DLT Solutions, LLC',
  'DMSI',
  'Docker, Inc.',
  'DocuSign Inc.',
  'DomainTools LLC',
  'Dongguan City Lang Jun Hardware Electronics Co.,Ltd',
  'Dover Corp.',
  'Draco Broadcast Inc',
  'Draper Inc.',
  'Draycor Inc',
  'Dremel',
  'DS Instruments',
  'DSLRKIT',
  'DTEN Inc.',
  'Dtrovision LLC',
  'Dualcomm Technology, Inc.',
  'Ducky',
  'Dun & Bradstreet',
  'Duro PC',
  'DWI Enterprises',
  'DX Engineering Inc',
  'Dynasty Communications',
  'DynaTrace LLC',
  'E3',
  'E3D-Online Ltd.',
  'Eagle Manufacturing',
  'East Coast Datacom',
  'Eastman Kodak Co.',
  'Easy Agile Pty LTD',
  'EasyMountLCD.com',
  'Eaton Corp plc',
  'eBay.com',
  'Echogear',
  'Echosec Systems, LTD',
  'ECI Defense Group',
  'ECS Composites',
  'Edco Source',
  'Eightwood',
  'EIS Inc.',
  'ej-technologies GmbH',
  'Ekahau, Inc.',
  'Elasticsearch BV',
  'Elecraft, Inc.',
  'Electric Sheep Fencing LLC',
  'Electriduct, Inc.',
  'Electronic Systems Protection, Inc.',
  'Elite Motion Systems LLC',
  'Ellenberger & Poensgen GmbH',
  'Elo Touch Solutions, Inc.',
  'Elotek Systems Inc',
  'EMC Corp.',
  'EMCO ehf.',
  'Emcor Enclosures',
  'Emenda',
  'Emergent, LLC',
  'Emerson Electric Co.',
  'EMKA Group',
  'Empire level',
  'Empower RF Systems Inc.',
  'Endace Ltd',
  'Energizer Holdings, Inc.',
  'EnerSys Delaware Inc.',
  'ENET Solutions, Inc',
  'Engage Communication Inc.',
  'Enhanced Network Systems',
  'EN-Labs',
  'Enterprise Integration',
  'EnterpriseDB Corp.',
  'Entrust Datacard Corp',
  'EON Instrumentation Inc.',
  'Eos Positioning Systems, Inc.',
  'ePadLink',
  'Epiphan Systems Inc.',
  'Epoch Concepts, LLC',
  'EPOS',
  'Equinix, Inc',
  'Equivio Inc.',
  'Eravant',
  'eReplacements, LLC.',
  'ErGear',
  'ErgoDirect.com',
  'Ergoguys LLC',
  'Ergotron',
  'ERICO International Corp.',
  'Erwin, Inc.',
  'ESE',
  'ESRI INC.',
  'Essendant Inc',
  'Essentra plc',
  'e-Systems Group, LLC',
  'Evans Capacitor',
  'Eventide Inc.',
  'Everbridge, Inc.',
  'Evertz Microsystems Ltd.',
  'EVGA Corp.',
  'Evoke Neuroscience, Inc.',
  'Evoluent, LLC',
  'EVS Supply',
  'Exabeam Inc.',
  'ExaGrid Systems, Inc.',
  'Excello Global Products',
  'EXCENTIA CONSULTORIA SL.',
  'EXFO Electro-Optical Engineering Inc.',
  'Exide Technologies',
  'Experian Information Solutions, Inc.',
  'ExterNetworks, Inc.',
  'ExtraHop Networks, Inc.',
  'Extreme Engineering Solutions, Inc',
  'Extreme Networks, Inc.',
  'Extron Electronics',
  "E-Z Spread N' Lift Industries",
  'F - Response',
  'F3EA',
  'F5 Networks, Inc.',
  'Facility Interiors Inc.',
  'Fadtech Telecom',
  'Fairwinds Technologies LLC',
  'Falcon Technologies, Inc.',
  'Fasmov',
  'Fastenal Co.',
  'FCN Technology Solutions',
  'FedResults, Inc.',
  'Fedsafes, LLC',
  'FEITIAN Technologies Co., Ltd',
  'Fellowes, Inc.',
  'Fiber Instrument Sales, Inc.',
  'Fiber Mountain Inc',
  'FiberCablesDirect.com',
  'Fiberconnectx Inc',
  'FiberPlex Technologies, LLC',
  'Fibertronics Inc.',
  'Fidelis Cybersecurity, INC.',
  'Field Components Inc',
  'Figma, Inc.',
  'FindTape',
  'FinePrint Software, LLC',
  'Finisar Corp.',
  'Firm Group',
  'Fitzgerald Spector Inc',
  'Flashpoint Global Partners',
  'Flexera Software, Inc.',
  'FLIR Thermal Infrared Camera Systems, Inc.',
  'Fluke Corporation',
  'Fluxlight, Inc.',
  'FlyBoys',
  'Flypro',
  'Forcepoint LLC',
  'Forensic Computers, Inc.',
  'Forescout Technologies, Inc.',
  'ForgeRock, Inc.',
  'Formax',
  'Formlabs Inc.',
  'Fornetix LLC',
  'Fortinet Inc.',
  'Fortive Corp',
  'Fortra LLC',
  'Forward Networks Inc',
  'Fosmon Distributing',
  'Fotronic Corp',
  'Four Points Technology',
  'Foxit Software Company, LLC',
  'Fractal Design',
  'Freelance Electronics',
  'Freeport Technologies, Inc.',
  'Frequency Electronics, Inc.',
  'Friedhelm Loh Group',
  'fs.com Inc',
  'FSR Inc.',
  'Fujifilm Holdings Corp.',
  'Fujikura Ltd.',
  'Fujitsu Group',
  'Full Compass Systems, LTD',
  'Fusion3 Design, LLC',
  'G.SKILL International Enterprise Co., Ltd',
  'Galco Industrial Electronics, Inc',
  'Garmin Ltd.',
  'Garvin Industries',
  'Gator Cases, Inc.',
  'GB & Smith',
  'GC Electronics',
  'GDMS',
  'GEARGO',
  'GearGrid',
  'GearWrench',
  'GeChic Corp',
  'GEEKOM',
  'Gemalto N.V.',
  'General Digital Corp.',
  'General Dynamics Corporation',
  'General Electric Co.',
  'General Printing & Design, Inc.',
  'General Standards Corp',
  'Gen-Pak Corp',
  'Genuitec, LLC',
  'George Risk Industries',
  'GET Engineering Corp',
  'Getac Technology Corp',
  'GetWireless LLC',
  'GFI Software Ltd',
  'Gigabyte Technology Co., Ltd.',
  'Gigamon Systems LLC',
  'GigaTech Products Inc.',
  'Gimmal LLC',
  'GitHub, Inc',
  'GitKraken',
  'GitLab, Inc',
  'Glassbridge Enterprises, Inc.',
  'Glenair, Inc.',
  'Glenbrook Technologies, Inc.',
  'Global Equipment Company Inc',
  'Global Fire Equipment',
  'Global Printed Products',
  'GlobalMedia Group, LLC',
  'GlobalSCAPE Inc.',
  'GlobalTranz',
  'GMC TEK, LLC',
  'GME Supply',
  'GMG Systems, Inc.',
  'GN Netcom, Inc.',
  'Go2Marine',
  'Goal Zero LLC',
  'GoDaddy Operating Company',
  'GodSpin LLC',
  'GoEngineer, Inc.',
  'GoPro, Inc.',
  'Gordon Electric Supply Inc',
  'Gordon Electric Supply, Inc.',
  'goTenna, Inc.',
  'GovConnection, Inc.',
  'Government Acquisitions, Inc.',
  'GoVets',
  'GPO Display',
  'GPS Networking Inc.',
  'Gradus Group LLC',
  'GrammaTech, Inc.',
  'Granite Telecommunications',
  'Graybar Electric Company, Inc.',
  'Graybar Services Incorporated',
  'Great Lakes Case & Cabinet Co.',
  'Great Scott Gadgets',
  'Greenlee',
  'Grey Matter',
  'Gridiron IT',
  'Groupware Technology',
  'Gruber Industries, Inc.',
  'Grupo Carso SAB de CV',
  'Guangzhou Beike Photographic Equipment Factory',
  'Guangzhou Jiadu Electronic Technology Co. LTD',
  'Guangzhou Lention Electronic Technology Co. Ltd',
  'Guangzhou Sibo Electronic Technology Co., Ltd',
  'Guangzhou Weibin Case And Bag Co., Ltd',
  'Guangzhou Weibin Case And Bag Co., Ltd.',
  'Guardian Industrial Products',
  'Guidance Software, Inc.',
  'GuidePoint Security, LLC',
  'Gulf Signal Distributors LLC',
  'GumdropCases.com, LLC',
  'GVISION USA, Inc.',
  'Hacker Warehouse',
  'HAHEWEA',
  'HaiVision Systems, Inc.',
  'Hak5, LLC',
  'Halo Technology',
  'Ham Radio Outlet',
  'Hamilton Products Group, Inc.',
  'Hammond Mfg. Co. Inc.',
  'Hanson Rivet',
  'Hanwha Group',
  'Harbor Freight Tools',
  'HardDrivesDirect',
  'Harger Lighting & Grounding',
  'Hascall-Denke',
  'Hasco Inc.',
  'Hashi Corp',
  'HATCHBOX',
  'Haverford Systems Inc',
  'Havis, Inc.',
  'HCC Tactical',
  'HCL Technologies',
  'Heartland Customer Solutions, LLC',
  'HEBEI LINHAO METAL MANUFACTURING CO., LTD',
  'Heckler Design',
  'Heezy LLC',
  'HEICO Corp.',
  'HellermannTyton Corp.',
  'HelpSystems, LLC',
  'Henge Docks, LLC',
  'Hetnet',
  'Hewlett Packard Enterprise Company',
  'Hex-Rays SA',
  'HID Corp.',
  'Hie Electronics, Inc.',
  'High Sec Labs Ltd',
  'Higher Ground Gear',
  'Highfine',
  'Highlander Partners LP',
  'Highsoft AS',
  'Highwings',
  'HII Unmanned Systems',
  'HISCO, Inc.',
  'Hisense Co., Ltd',
  'Hitachi, Ltd.',
  'Hoffman Technologies',
  'Holson Solutions Group',
  'Home Depot',
  'Homespot',
  'Hon Hai Precision Industry Co., Ltd.',
  'Honeywell International Inc.',
  'Hoodman Corp.',
  'Horn Textile, Inc',
  'Hosa Technology, Inc.',
  'HPI Federal LLC',
  'HSM GmbH Co.',
  'HTC Corp.',
  'Hubbell Inc.',
  'HUBER+SUHNER AG',
  'Huel Technology.',
  'Hughes Network Systems, LLC',
  'Huizhou City LATU Photographic Equipment Co, Ltd.',
  'Huizhou Kumeir Technology Co. LTD',
  'Hunan Ocean Wing E-commerce Technology Co., Ltd.',
  'HYCU, Inc.',
  'Hylec-APL',
  'HyTrust, Inc',
  'I/OMagic Corp.',
  'I2R Electronics Inc.',
  'i-Blason LLC',
  'IBM Corporation',
  'IC Intracom',
  'IC Intracom Italia S.p.A.',
  'ICC Corp',
  'Icebox Network SL',
  'ICI Touch Technology Inc.',
  'Icom America',
  'Icron Technologies Corp.',
  'Icy Dock',
  'ID Integration, Inc.',
  'ID Tech',
  'IDEAL Electrical',
  'Identification Specialists, LLC',
  'Identify Systems',
  'IdentiPHI Inc.',
  'Identiv Inc',
  'Identiv, Inc.',
  'Idera Inc.',
  'IDM Computer Solutions, Inc.',
  'iFixit',
  'IGEL GmbH',
  'iguangxing Luggage Manufacturing Co., Ltd',
  'ikan Corp',
  'iKey, Ltd',
  'Ikling LLC',
  'Illinois Tool Works Inc.',
  'Imagine Communications Corp.',
  'Immersion CyKor, LLC',
  'immixTechnology, Inc.',
  'Impero Electronics, Inc.',
  'Imperva Inc.',
  'IMPRES Technology Solutions',
  'Imprivata, Inc.',
  'Inateck',
  'Incipio Technologies, Inc.',
  'Indeni LTD',
  'Industrial Webbing Corp',
  'InetSoft Technology Corp.',
  'Infinera Corp',
  'InfinID Technologies, Inc',
  'Infinite Cables Inc.',
  'Infinite Electronics',
  'Infinity Technology LLC',
  'Infiniwing Inc',
  'Infoblox Inc.',
  'InFocus Corp.',
  'Infolock Technologies',
  'Information Assurance Specialists, Inc.',
  'Information Security Corp.',
  'Infosec Institute',
  'Infragistics, Inc.',
  'Ingenico Group',
  'Ingram Micro Inc.',
  'inMusic Brands, Inc',
  'Innovation First, Inc.',
  'Innovative Wireless Technologies Inc.',
  'Innovelis Inc.',
  'INOGENI, Inc.',
  'InPixal',
  'Inpixon',
  'InQuest, LLC',
  'Inracks Inc',
  'Insight Public Sector, Inc.',
  'InSource, Inc.',
  'InstallerParts',
  'Instruments Inc.',
  'Integral Consulting Services, Inc',
  'Integrated Biometrics, LLC',
  'Integrated Logic Solutions LLC',
  'Integration Technologies Group, Inc.',
  'INTEL 471 INC.',
  'Intel Corp.',
  'Intelligent Computer Solutions, Inc.',
  'Intelligent Waves LLC',
  'Intelsat',
  'Interactive Media Corp',
  'Inter-Coastal Electronics',
  'Intergral GmbH',
  'InterTest',
  'Intertex Electronics Inc',
  'InterWorld Highway, LLC',
  'Intuit Inc.',
  'INVERTERTEK',
  'INVISIO Group',
  'IODD Co. LTD.',
  'Ipro Tech, LLC',
  'IPSwitch, Inc.',
  'Iridium Communications Inc.',
  'Iris Technology Corp',
  'I-Rocks Technology Co., Ltd',
  'Iron Bow Technologies, LLC',
  'Iron Mountain Inc.',
  'Isode, Ltd.',
  'iSoft Solutions, LLC',
  'iStarUSA, Inc.',
  'IT Bargain Center',
  'IT Hardware Discounts',
  'ITAC Systems, Inc.',
  'ITD Itanda',
  'I-Tech Company',
  'Ivanti Software, Inc',
  'Ixever',
  'Ixia',
  'iXsystems, Inc.',
  'JACO, Inc.',
  'Jadex Inc.',
  'JAG Electric',
  'JAM Software GmbH',
  'Jameco Electronics',
  'JAMF Software, LLC',
  'Jason Cases',
  'Jay Worch Electric, LLC',
  'JEGS High Performance',
  'Jelly Comb Corp.',
  'JEM Tech Group',
  'Jeron Electronics Systems, Inc.',
  'Jeskell Systems LLC',
  'JetBrains, s.r.o.',
  'JFrog Ltd',
  'JFW Industries Inc',
  'JMC Global Technologies',
  'JMC Global Technologies, I, L.P.',
  'JMR Electronics, Inc.',
  'Johnson Controls International plc',
  'Jonard Industries Corp',
  'Jonathan Engineered Solutions',
  'JOUNIVO',
  'JSCAPE LLC',
  'Juggernaut Defense, LLC',
  'Juicebox',
  'JumpMind Inc.',
  'Juniper Networks, Inc.',
  'Just Great Software Co. Ltd.',
  'Justrite Mfg. Co., L.L.C',
  'Juvare',
  'JVCKENWOOD Corp.',
  'JXMOX',
  'K L Security Enterprises',
  'K15t GmbH',
  'KAGWERKS',
  'Kaminario Inc.',
  'Kanex',
  'Kantek, Inc.',
  'Kanto',
  'Kassa',
  'KEF',
  'Kelyn Technologies, Inc',
  'KEMP Technologies, Inc.',
  'Kendall Howard LLC',
  'Kepco Power',
  'Kerberos International, Inc.',
  'Keysight Technologies Inc.',
  'KI',
  'Kinedyne LLC',
  'Kingston Technology Company, Inc.',
  'Kioxia',
  'KITCO Fiber Optics',
  'KLB Enterprises',
  'Klein Tools, Inc.',
  'Knipex',
  'KnowBe4, Inc.',
  'KnowWare International, Inc.',
  'Kofax Inc.',
  'Kohler Co.',
  'KOL Global Logistics',
  'KoldLok',
  'Komodo Laboratories LLC',
  'Komprise, Inc.',
  'Kong Inc.',
  'Kongsberg Spacetec AS',
  'Konica Minolta, Inc.',
  'Koninklijke Philips N.V.',
  'Kooltronic Inc.',
  'Kopis Mobile LLC',
  'Koss Corp.',
  'Kpaul Properties LLC',
  'Kramer Electronics Ltd.',
  'Kratos Defense & Security Solutions, Inc.',
  'Kreg',
  'Kriaanet',
  'KRIEGER',
  'Krylon',
  'KSI Professional LLC',
  'KVM Switches Online, LLC',
  'KWizCom Corp.',
  'Kymeta Corp',
  'L&H Enterprises',
  'L&W Supply',
  'L.H. Dottie Co',
  'L3Harris Technologies, Inc.',
  'Laird Connectivity',
  'Lambda Labs, Inc.',
  'Lantronix, Inc.',
  'Lars Thrane A/S',
  'Larson Packaging Company, LLC',
  'Lascomm',
  'Laser Bonding Technology',
  'L-Com, Inc.',
  'LDO Systems',
  'Le Donne',
  'Learning Tree International',
  'Legrand SA',
  'Lenovo Group, Ltd.',
  'Levine Leichtman Capital Partners Inc',
  'Leviton Manufacturing Co.',
  'Levitt Industrial Textile',
  'Lexar Industrial',
  'Lexmark International, Inc.',
  'Leyard Optoelectronic Co',
  'LF LLC',
  'LG Corp.',
  'Liberty Diversified Industries',
  'LibXL',
  'Liferay, Inc.',
  'LifeSize, Inc.',
  'Lift-All',
  'Liftking Manufacturing Corp.',
  'Ligado Networks',
  'Lighthouse Office Supply',
  'Lightware',
  'Limitless Innovations Inc',
  'Lin Engineering',
  'Lind Electronics, Inc.',
  'LINDY International Limited',
  'LINDY-Elektronik GmbH',
  'Linear Technology Corp.',
  'LinkedIn Corp.',
  'LinQuest Corporation',
  'Liqid Inc.',
  'Liquidware Labs, Inc.',
  'Listen Technologies Corp.',
  'Liteway, Inc.',
  'LMT LICHTMESSTECHNIK GMBH BERLIN',
  'LoadBalancer.Org, Inc.',
  'Lockheed Martin Corp.',
  'Logicube, Inc.',
  'Logitech Inc.',
  'LogRhythm Inc.',
  'Longsintek LTD',
  'Lowell Manufacturing Co.',
  'LPKF Laser & Electronics AG',
  'LS Cable & System LTD',
  'LS Group',
  'L-Soft International, Inc.',
  'LSoft Technologies Inc.',
  'LTI DataComm, Inc.',
  'Lucid Software Inc',
  'Lumen Technologies',
  'Lumina Industries, Inc.',
  'Lumivero LLC',
  'Lutron Electronics Co., Inc.',
  'Luxo',
  'Luxtude',
  'Luxul Corp.',
  'LXE',
  'Lynn Electronics Inc.',
  'M.Klemme Technology Corp.',
  'Ma Laboratories, Inc.',
  'Mac Business Solutions, Inc.',
  'Mac Tools',
  'Macally U.S.A Mace Group, Inc.',
  'Madison Electric Products',
  'Madison Seating',
  'Magdaddy LLC',
  'Magic Leap, Inc.',
  'Magline, Inc.',
  'MAGNASPHERE Corp.',
  'Magnet Forensics Inc.',
  'Mainline Computer Products, Inc.',
  'Mainline Information Systems',
  'Major Custom Cable Inc.',
  'Makita Corp.',
  'Mallory Sonalert Products, Inc.',
  'Mark Wilson Software Ltd.',
  'Marshall Electronics, Inc.',
  'Marshall Furniture Inc.',
  'Martin International Enclosures Inc.',
  'Marvell Technology Group Ltd',
  'Marway Power Solutions, Inc.',
  'Master Cable',
  'Master Electronics',
  'Master Lock Co LLC',
  'MasterBrand Cabinets',
  'Masterclock, Inc.',
  'Matias Corp.',
  'Matrox Electronic Systems Ltd',
  'MatterHackers',
  'Mattermost, Inc.',
  'Maury Microwave Corp.',
  'Maxim Integrated Inc.',
  'MC3 Technologies',
  'McAfee LLC',
  'MCLI',
  'McMaster-Carr Supply Co.',
  'MDClone Ltd',
  'Mechanical Keyboards, LLC',
  'Mechanical Plastics Corp.',
  'Mechdyne Corp.',
  'Media Supply, Inc.',
  'Medicus Health',
  'Medline',
  'Med-Pat, Inc.',
  'Megger Group Ltd.',
  'Mellanox Technologies, Ltd',
  'Melrose Industries Plc',
  'Melrose Industries, Plc',
  'MelroseMAC',
  'MemoryTen, Inc.',
  'Mencom Corp',
  'Mencom Corporation',
  'Mercury Systems, Inc.',
  'Merlin Technical Solutions',
  'Meta',
  'Meta Camera Ltd.',
  'Metadot Corp.',
  'Metal Master, Inc.',
  'Metallics Inc.',
  'Metal-Tech Partners',
  'Metropolitan Vacuum Cleaner Company, Inc',
  'MFJ Enterprises Inc.',
  'MFJ Enterprises, Inc.',
  'Micro Focus International plc',
  'Micro USA, Inc.',
  'Microchip Technology Inc.',
  'Microcom Technologies, Inc.',
  'MicroGate Systems LTD',
  'Micron Technology, Inc.',
  'MicroNet Technology',
  'Micropac Technologies, Inc',
  'MicroPact Inc.',
  'Microsemi Corp.',
  'Microsoft Corp.',
  'MicroStrategy, Inc.',
  'MicroTech',
  'Microtech, Inc.',
  'Microtechnologies, Inc.',
  'Midland',
  'Midwest Unlimited',
  'MikroTik',
  'MILAPEAK',
  'MilDef AB',
  'Milestek Corp.',
  'Milestone Systems A/S',
  'Military Pilot Supply of Texas, Inc.',
  'Milky House',
  'Millennium Computer Products',
  'Milltech Marine',
  'Milpower Source',
  'Milwaukee Electric Tool Corp.',
  'MIN CI',
  'Mind Media USA Inc.',
  'Minerallac Co',
  'Mini-Circuits',
  'miniOrange Inc.',
  'Mirantis Inc.',
  'Miro',
  'Mission Critical Solutions',
  'MiTek Corp.',
  'Mitsubishi Electric Corp.',
  'Mitutoyo Corp',
  'Mi-WAVE',
  'MNJ Technologies',
  'Mobile Pixels Inc',
  'MobileIron, Inc.',
  'ModTech Solutions, LLC',
  'Molex Inc.',
  'MongoDB, Inc.',
  'Monoprice, Inc.',
  'Monster Worldwide, Inc.',
  'Moog Inc.',
  'mophie LLC',
  'Morad Antenna Company',
  'Mothers',
  'Motorola Solutions, Inc.',
  'MOTU, Inc.',
  'Mounting Dream',
  'Mount-It',
  'Mouser Electronics, Inc.',
  'Moxie MOD, LLC',
  'Mrsupply.com',
  'MSC',
  'MSI Computer Corp',
  'MuleSoft Inc.',
  'Mullvad VPN',
  'Multi-Tech Systems, Inc.',
  'Murata Manufacturing Co. Ltd.',
  'Mushkin, Inc.',
  'Music Tribe Global Brands Ltd.',
  'MuxLab Inc.',
  'My Computer Works, Inc.',
  'My Smart Logon SAS',
  'MyDigitalSSD',
  'Myers Industries, Inc.',
  'MYGOFLIGHT',
  'Mythicsoft Ltd',
  'MZ-Tools',
  'N1 Critical Technologies, Inc.',
  'n2grate',
  'Nagios Enterprises, LLC',
  'NAL Research Corp',
  'Nanjing Magewell Electronics Co., Ltd',
  'Nanoprecise',
  'Napatech A/S',
  'Nassau Electrical Supply',
  'National Brand',
  'National Instruments Corp.',
  'National Products Inc.',
  'NavePoint, LLC',
  'NavRuf',
  'Navtech GPS',
  'NCover LLC',
  'NCS Technologies, Inc.',
  'NCSS, LLC',
  'NEC Corporation',
  'NEIKO',
  'Nemix Corp',
  'NetAcquire Corp',
  'NetAlly',
  'NetApp, Inc.',
  'NetBrain Technologies, Inc.',
  'Netgear, Inc.',
  'NetIQ Corporation',
  'Netreo, Inc.',
  'Netria Corporation',
  'Netscout Systems Inc.',
  'NetSource, Inc.',
  'Netsparker Ltd',
  'NetSupport Group',
  'Netsync',
  'Network Alliance Inc',
  'Network Integrity Systems, Inc.',
  'Network Solutions Center / CSO',
  'NetworkTigers, Inc.',
  'Neumetrix LTD',
  'Neuro Logic Systems, Inc.',
  'Neutrik AG',
  'Newegg',
  'Newell Rubbermaid Inc.',
  'NewerTech, Inc.',
  'NEWHEY',
  'Newline Interactive Inc.',
  'Newport Corp.',
  'NewTek, Inc.',
  'Nexans S.A.',
  'Nexenta Systems, Inc.',
  'Nexight INC.',
  'Niagara Networks Inc',
  'NIDA Corporation',
  'Nikon Inc.',
  'NIKSUN, Inc.',
  'Niveo Professional',
  'nlyte Software, Ltd',
  'No NDA inc',
  'Noble Security Inc.',
  'Noctua',
  'Nokia Corp.',
  'Norseman Defense Technologies',
  'Norstar Source LLC',
  'NortonLifeLock Inc',
  'NovaStar Tech',
  'NovaVision Inc.',
  'NoviFlow Inc',
  'NovoDynamics, Inc.',
  'NovoTech',
  'NowSecure Inc',
  'Nozomi Networks',
  'NSGDatacom, Inc.',
  'NSi Industries, LLC',
  'NSX Technologies Inc.',
  'ntop',
  'Nuance Communications, Inc.',
  'Nucleus Cyber, Inc',
  'NuDesign Technologies, Inc.',
  'Nuix Pty Ltd',
  'Nutanix, Inc.',
  'Nuvair',
  'NuWaves Engineering',
  'nVent Electric plc',
  'NVIDIA Corp.',
  'NZXT Corp.',
  'Oatey CO',
  'Oberon Wireless, Inc',
  'Objectivity Inc.',
  'OBSS Teknoloji Anonim Sirketi',
  'Oculus Photonics',
  'ODI',
  'Okta Inc',
  'OLB Associates LLC',
  'Olight Technology Co.Ltd.',
  'Olympus Corp.',
  'Omniprogear',
  'Omnitron Systems Technology, Inc.',
  'One Diversified, LLC',
  'One Stop Systems, Inc.',
  'Onefinity',
  'OneTigris Co.',
  'OneWeb Technologies, Inc',
  'Onix Networking Corp.',
  'Onkyo & Pioneer Corp.',
  'Onshape',
  'OPDEC',
  'Open Text Corp.',
  'Open-E, Inc.',
  'Opengear, Inc.',
  'OPPO Digital, Inc.',
  'Ops-Core',
  'Opsview LTD',
  'OPSWAT, Inc.',
  'Optical Cable Corp.',
  'Optical Wavelength Laboratories, Inc.',
  'Opticis Co., Ltd.',
  'Opticonn Inc.',
  'Optimum Solutions Engineering',
  'Optiv Security Inc.',
  'Optivor Technologies, LLC',
  'Oqton',
  'Oracle Corp.',
  'Orbia Advance Corporation S.A.B. de CV',
  'Orbis Technologies, Inc.',
  'Orbital Research Ltd',
  'Orca Technologies',
  'Orolia SAS',
  'Other World Computing',
  'Otter Products, LLC',
  'Overland Storage, Inc.',
  'Owl Cyber Defense',
  'Own The Night',
  'PACE, Inc.',
  'Pacific Star Communications',
  'Packaging Strategies, Inc.',
  'Paessler AG',
  'Pakedge Device & Software Inc.',
  'Paladin Technologies',
  'Palo Alto Networks, Inc.',
  'Panasonic Corp.',
  'Panda Wireless Inc',
  'Panduit Corp.',
  'Panorama Antennas Ltd',
  'Paperlike',
  'Para Systems, Inc.',
  'PARADIGM',
  'Paragon Micro Inc.',
  'Parallels IP Holdings GmbH',
  'Paramount Software UK LTD',
  'Park Place Technologies',
  'Parker Group, Inc.',
  'Parraid LLC',
  'Part Target',
  'Parts Express',
  'PartsVu',
  'Passware, Inc.',
  'PATCHBOX',
  'Patton Electronics Co.',
  "PATTON'S INC",
  'PC PitStop',
  'PCNation',
  'PCSP',
  'PDi Communication Systems Inc.',
  'PDQ.com Corporation',
  'Peer Software, Inc.',
  'Peerless Industries, Inc.',
  'PEGATRON Corp',
  'Pelican Products, Inc.',
  'Penn Elcom LTD',
  'Pentair, Inc.',
  'PepLink',
  'Perforce Software, Inc.',
  'Perle Systems, Ltd.',
  'Permasleeve',
  'Perm-A-Store, Inc.',
  'Persistent Systems, LLC',
  'Pesa',
  'Petechtool',
  'PetroSys Solutions Inc. dba psitechnology',
  'Petzl',
  'PFMAN LLC',
  'Phanteks Co.',
  'Phidgets Inc.',
  'Phillips Corp.',
  'Phoenix Audio Technologies',
  'PHOENIX CONTACT GmbH & Co. KG',
  'Phrontier Technologies LLC',
  'Pi Manufacturing Corp.',
  'Pilot Communications USA',
  'Pioneer Industries, Inc',
  'PioneerPOS Inc.',
  'Pipishell',
  'Pitney Bowes Inc.',
  'Pivot3 Inc.',
  'Pivotal Software, Inc.',
  'Planar Systems, Inc.',
  'Plantronics, Inc.',
  'Plasternack',
  'Platinum Tools Inc.',
  'PLATT',
  'Plexim GMBH',
  'Plugable Technologies',
  'Plusivo',
  'pmc-Sierra, Inc.',
  'PNY Technologies, Inc.',
  'Poly',
  'Poolweb.com',
  'PortSwigger LTD',
  'POSGlobal.com',
  'Postman Inc.',
  'POTEK',
  'Potomac Instruments, Inc.',
  'Powerbuilt Tools',
  'Powersoft S.p.A.',
  'Power-Sonic Corp.',
  'Powertec',
  'Powerwerx',
  'Pragma Systems, Inc.',
  'Precision Group',
  'Preformed Line Products Co.',
  'Premier Conduit',
  'Premier Farnell plc',
  'Premier Fire & Security, Inc.',
  'Premier LogiTech, LLC',
  'Premier Mounts',
  'Premier Services & Solutions',
  'Presagis Inc.',
  'Presidio',
  'Presidio Networked Solutions, Inc',
  'Preston hardware',
  'PrimeKey Solutions AB',
  'Primer AI',
  'Primera Technology, Inc.',
  'PrimeSource Building Products, Inc.',
  'Primus Cable',
  'PrinterLogic',
  'Pro Access Floors',
  'ProCases Inc',
  'Procter & Gamble Co.',
  'ProCustom Group',
  'ProDuplicator',
  'Progress Software Corp.',
  'Progressive Business Technology Training',
  'Proline Options',
  'Pro-Lite, Inc.',
  'Promise Technology, Inc.',
  'Proofpoint, Inc.',
  'Proto Tools',
  'Pro-Twist',
  'Provantage LLC',
  'Prysmian Group',
  'PtouchDirect',
  'PTS Expeditionary Communications',
  'PTS, Inc.',
  'Pulse Secure, LLC',
  'Pulse Supply',
  'Puppet Labs, Inc.',
  'Pure Storage, Inc.',
  'PureWrx',
  'Qmulos',
  'QNAP Systems, Inc.',
  'Qotilabs SAS',
  'QSC Audio Products, LLC.',
  'Qt Group Oyj',
  'Quail Electric',
  'Qualtrics, LLC',
  'Qualys, Inc.',
  'Quam Nichols Co.',
  'Quantic Electronics',
  'Quantum Corp.',
  'Quark Software Inc.',
  'Quest Software Inc.',
  'QuickTreX',
  'Quicktron',
  'Quill Lincolnshire, Inc.',
  'Qumulo, Inc.',
  'QVS, Inc.',
  'Racal Acoustics Inc.',
  'Rack-A-Tiers Mfg Inc',
  'Rackmount Solutions, Ltd',
  'Rackstuds',
  'RackSystems',
  'RAD Group',
  'Radiant Logic, Inc.',
  'Radiant RFID, LLC.',
  'Radio Depot',
  'Radwell International, Inc.',
  'Rain Design Inc.',
  'Raloy, Inc.',
  'Ramsey Electronics, LLC',
  'Rapid Care',
  'Rapid7 LLC',
  'Rascom Computerdistribution Ges.m.b.H.',
  'Rave Computer Association, Inc',
  'Raytheon Technologies Corp',
  'Razer Inc.',
  'RB Enterprises',
  'RC Logger - reject 071019',
  'RCI Custom Products',
  'Real Time Monitors, Inc.',
  'REAN Cloud LLC',
  'Recast LLC',
  'Recorded Future, Inc.',
  'Red Gate Software, Ltd.',
  'Red Hat, Inc.',
  'Red River',
  'Redco Audio Inc',
  'RedSky Technologies, Inc.',
  'Regency Space Solutions',
  'Regional Supply',
  'Rei',
  'RELX Group',
  'reMarkable AS',
  'Renkchip',
  'Revopoint 3D Technologies Inc.',
  'Rexel SA',
  'RexQualis, Inc.',
  'RF IDeas, Inc',
  'RF Industries',
  'RF Parts Co',
  'RGB Spectrum, Inc.',
  'RGS',
  'Richard Tool',
  'Ricoh Company, Ltd.',
  'Ridgeline Technology',
  'RightStar Inc.',
  'Ripley Tools LLC',
  'RiskIQ, Inc',
  'RITEC',
  'Riverbed Technology, Inc.',
  'Robotron Group',
  'Rock Exotica LLC',
  'Rocket Software, Inc.',
  'Rocketfish Products',
  'RockITek',
  'Rocky Mountain Ram, LLC.',
  'Rocstorage, Inc.',
  'RODE Microphones',
  'Rogan Corporation',
  'Rohde & Schwarz',
  'ROHM CO LTD',
  'Roland DGA Corp',
  'Romeo Six, LLC',
  'Root Logistics, LLC',
  'Rose Electronics',
  'Rosewill Inc.',
  'Route1 Inc.',
  'RoutersWholesale',
  'Rovi Corp.',
  'RS Microwave Company, Inc.',
  'RSA Security LLC',
  'RTD Embedded Technologies, Inc.',
  'RTL Materials Ltd',
  'Rubrik, Inc.',
  'Runtime Technologies LLC',
  'Russ Bassett Corp.',
  'S&S Precision',
  'S.P. Richards Co',
  'S7 extension cord',
  'Sabrent',
  'SAFCORD',
  'SafeNet, Inc.',
  'Safran Electrical & Power',
  'Saft SAS',
  'SAICOO Tech',
  'Sailrite',
  'Salamander Designs Ltd.',
  'Salesforce.com',
  'Saltstack Inc',
  'SAMCOM',
  'Samsonite Corp.',
  'Samsung Group',
  'SanDisk Corp.',
  'Sanho Corp.',
  'SanSpot',
  'SanSpot Inc.',
  'SAP SE',
  'SAPIEN Technologies, Inc.',
  'Sariana LLC',
  'Satellitephonestore.com',
  'Satori Software, Inc.',
  'Saviynt Inc',
  'Scala, Inc.',
  'ScanSource, Inc.',
  'Schneider Electric SA',
  'School Outfitters',
  'Schweitzer Engineering Laboratories, Inc.',
  'SCI Technology, Inc.',
  'ScienceLogic, LLC',
  'Scientific Data Systems, Inc.',
  'Scooter Software, Inc.',
  'Scotch',
  'Scott Brand',
  'ScreenBeam, Inc.',
  'SDV Solutions, Inc.',
  'Sea Sonic Electronics Co., Ltd',
  'Sea-Dog Corporation',
  'Seagate Technology LLC',
  'Seagull Scientific, Inc.',
  'Seal Shield Corp.',
  'Sealing Technologies Inc.',
  'Sears Holdings Corp.',
  'Sea-tronics',
  'Seatronx',
  'SecuGen Corp.',
  'Secure Cable Ties',
  'SecureData Inc',
  'Security Compass LTD',
  'Security Engineered Machinery',
  'Security Onion Solutions LLC',
  'Sedna Advanced Electronics Ltd.',
  'SEH Computertechnik GmbH',
  'SEI, Inc',
  'Seiko Epson Corp.',
  'Semantic Research, Inc.',
  'Sena Technologies, Inc.',
  'Senao Networks, Inc.',
  'Sennheiser Electronic Corp.',
  'Sensaphone, Inc.',
  'Senspex, Inc.',
  'Server Supply',
  'Server Technology, Inc.',
  'ServiceNow, Inc.',
  'ServiceRocket, Inc',
  'Sewell Development Corp',
  'SGT KNOTS Supply Co.',
  'ShadowTech Solutions',
  'Sharegate Group Inc',
  'SharkRack, Inc.',
  'Sharp Corp.',
  'Shaxon',
  'Shenzhen BESTEK Technology Co LtD',
  'Shenzhen Century Cheng Technology Co., Ltd',
  'Shenzhen Hairongchang Technology Co. LTD',
  'Shenzhen Henghongshun Technology Co. LTD',
  'Shenzhen NearbyExpress Technology Development Company Limited',
  'Shenzhen Pulinkai Technology Co. LTD',
  'Shenzhen Snapmaker Technologies Co., Ltd.',
  'Shenzhen Wodike Technology Co. LTD',
  'Shenzhen Xinchuangfeng Technology Co. LTD',
  'Shenzhen Xinhaobo Technology Co. LTD',
  'Shenzhen Xunqi Technology Co,. Ltd',
  'Shenzhenshi Lisiting Keji Youxiangongsi',
  'SHI International Corporation',
  'Shine Micro',
  'Shlomo Group',
  'Shokz Holding Ltd.',
  'Shoplet',
  'Shop-Vac Corp',
  'Shure Inc.',
  'Sicura',
  'SIDUS Solutions LLC',
  'Siemens AG',
  'Siemon',
  'Sierra Nevada Corporation',
  'Signamax Inc.',
  'SIIG Inc.',
  'Silico Systems, LLC',
  'Silicon Forensics Inc.',
  'Silicon Mechanics, Inc.',
  'Silicon-Power Computer & Communications Inc.',
  'Silvus Technologies, Inc.',
  'Simio LLC',
  'Simply NUC, Inc.',
  'Simtec LTD',
  'Simulaids Ltd',
  'Sirius Federal',
  'SKB Corporation, Inc.',
  'Skillsoft LTD',
  'Skybox Security, Inc.',
  'SkyGeek',
  'Skylotec',
  'Smarsh, Inc.',
  'Smart Technologies, Inc.',
  'SmartAVI, Inc.',
  'SmartBear Inc.',
  'SmartDraw Software, LLC',
  'SmartSAT Inc.',
  'Smartsheet Inc.',
  'SmartSign',
  'Smead Manufacturing Company, Inc.',
  'Smithy',
  'SMK Corp.',
  'SML Enterprises, Inc.',
  'SML Group',
  'SmugDesk',
  'SnakeClamp Products LLC.',
  'Snap-on Inc.',
  'SNR Systems LLC',
  'Socrata, Inc.',
  'SoftArtisans Inc.',
  'Software AG, Inc.',
  'Software Techniques, Inc.',
  'SolarWinds, Inc.',
  'Sole Source Technology, LLC',
  'Solo New York',
  'Soluciones Gráficas por Ordenador S.L.',
  'Solvix Solutions, LLC',
  'SON Technology',
  'SonarSource SA',
  'Sonatype Inc.',
  'S-One Holdings Corp.',
  'SonicWALL, Inc.',
  'Sonnet Technologies, Inc.',
  'Sonos, Inc.',
  'Sony Corporation',
  'Sony Electronics Inc.',
  'Sophos Plc.',
  'Sotel Systems, LLC',
  'Sound Control Technologies Inc.',
  'South Ark Telecom LLC',
  'Southco, Inc.',
  'Southland Fabrication',
  'South-Pak, Inc.',
  'Southwire Co.',
  'SpaceX',
  'Sparx Systems Pty Ltd.',
  'SPC Industrial',
  'SPC Technology',
  'Specialty Cases, Inc.',
  'Specialty Products of Virginia',
  'Speck Products Inc.',
  'Speco Technologies',
  'Spectra Logic Corp.',
  'Spectracom Corp.',
  'Spectris plc',
  'Sperry Software, Inc.',
  'Spigen, Inc.',
  'SpinetiX SA',
  'Spirent Communications plc',
  'Splunk, Inc.',
  'Spurtar',
  'Squared Up Ltd',
  'SquareGrove LLC',
  'Squirrels, LLC',
  'SRT Supply LLC',
  'SSR Engineering, Inc.',
  'ST Engineering Ltd',
  'STAGIL Corp.',
  'Stancil Corp',
  'Standard Technical Merchandise Pty, Ltd',
  'Stanley Black & Decker, Inc.',
  'Staples, Inc.',
  'Star Industries',
  'Stardog Union',
  'STAR-Dundee Ltd.',
  'Starfish Storage Corp.',
  'Starkey Headsets Group',
  'StarTech Computer Products',
  'Startechtel.com, Inc.',
  'StataCorp LP',
  'Static Safe Products Co.',
  'Stay Online Corp.',
  'Steel City Supply',
  'Steelcase Inc.',
  'SteelCloud LLC',
  'Steelray Software, LLC',
  "Steffe's & Company, LLC",
  'Stein & Associates LLC',
  'Stenner',
  'Stephen Gould Corp.',
  'Sterling Computers Corp',
  'Stewart Audio Inc.',
  'StiltSoft',
  'Stoneridge Inc.',
  'Stonewall Cable, Inc.',
  'StorageCraft Technology Corp.',
  'StorageHawk',
  'Stratasys LTD',
  'Strategic Communications, LLC',
  'Strategic Cyber, LLC',
  'Stratus Technologies, Inc.',
  'Street Smarts VR, Inc.',
  'Suitemate',
  'Sumitomo Electric Lightwave',
  'Sun City Constructors',
  'Sun Management',
  'SUNCORPORATION',
  'Sunderland Communications',
  'Sunhillo Corp',
  'Sunland International, LLC',
  'SUNLU',
  'SUNSHINE HOLDINGS FLORIDA LLC',
  'Supcase Inc.',
  'Super Electronics',
  'Super Micro Computer, Inc.',
  'Super Talent Technology Corp.',
  'SuperLogics Inc.',
  'Superna, Inc.',
  'SupplyNet, Inc.',
  'SureBonder',
  'Surge Suppression, LLC',
  'SurveyMonkey Inc',
  'Suse LLC',
  'Suunto',
  'SW Technologies',
  'Sweetwater',
  'Swish Data Corporation',
  'SYBA Tech Ltd.',
  'Symantec Corp.',
  'SymphonyAI Industrial',
  'Synack, Inc.',
  'Synchronized Technologies',
  'Synergy Global Inc.',
  'Synergy Micro Solutions',
  'Synology Inc.',
  'Syntech Electronics',
  'Sysorex Government Services, Inc.',
  'System Innovation Group, LLC',
  'Systematic Software',
  'Systematic Software Engineering Inc.',
  'Systemax Inc.',
  'SYSTRAN Software, Inc.',
  'T.A. Barker Associates, LLC',
  'Tableau Software, Inc.',
  'TACACS.net Inc',
  'Tactical Support Equipment Inc.',
  'Taft Electric Co',
  'Tangent, Inc.',
  'TapeandMedia.com LLC',
  'Targus Group International, Inc.',
  'TC Communications, Inc.',
  'TCG, LLC',
  'TD SYNNEX Corp.',
  'TE Connectivity LTD',
  'TEAC Corporation',
  'Team Group Inc.',
  'TeamViewer GmbH',
  'Tech Armor',
  'TechMatte Inc.',
  'Technica Corp.',
  'Technical Communities, Inc.',
  'Technologies For Tomorrow, Inc.',
  'Technology Advancement Group, Inc.',
  'TechSmith Corp.',
  'Tecplot, Inc.',
  'TekRepublic',
  'TEKTELIC Communications Inc.',
  'Telcobuy',
  'Teledyne Technologies Inc.',
  'Teletronic',
  'Tellabs, Inc.',
  'Telnet Labs, Inc.',
  'Tempered Networks Inc',
  'Tempo Communications, Inc.',
  'Tempo ehf.',
  'Tenable Network Security, Inc.',
  'TEquipment',
  'Teradek LLC',
  'Teradici Corp.',
  'Tesla, Inc.',
  'TESSCO Technologies Inc',
  'TestEquity LLC',
  'Testforce',
  'Texas Instruments Inc.',
  'Text Control GmbH',
  'TGU GmbH & Co. KG',
  'Thales Group, Inc.',
  'The Audio Visual Co.',
  'The better bungee',
  'The BILCO Company',
  'The Connectivity Center',
  'The Dewey Electronics Corporation',
  'The Gorilla Glue Company',
  'The Laminex Family of Companies',
  'The Light Connection, Inc.',
  'The MathWorks, Inc.',
  'The MaxCell Group',
  'The Moxa Group',
  'The Music People Inc.',
  'The Neat Co.',
  'The Omni Group',
  'The Starware LTD',
  'The Tiffen Company, LLC',
  'The UNC Group',
  'The Whitlock Group',
  'Thermaltake Technology Co., Ltd.',
  'Thermo Fisher Scientific Corp.',
  'Think Benfei',
  'Thinkmate',
  'Thor Broadcast',
  'ThousandEyes Inc.',
  'Three Wire Systems, LLC',
  'Thronmax LLC',
  'Thule Group',
  'TIBCO Software Inc.',
  'Tiger Supplies, Inc.',
  'TIMBOOTECH',
  'Timbuk2 Designs, Inc.',
  'Time Warner Inc.',
  'TimeMachines, Inc.',
  'Tintri, Inc.',
  'Titania LTD',
  'TitanUS Technologies LLC',
  'Titus Inc.',
  "Today's Classroom LLC",
  'Tomball Computer Guy',
  'Tonex, Inc',
  'Toolour',
  'Top Flight, Inc.',
  'Topaz Systems, Inc.',
  'Toshiba Corp',
  'Total Micro Technologies Inc.',
  'Total Site Solutions, Inc.',
  'Totowa Systems Inc',
  'Tower Products Inc',
  'Tower Products Inc.',
  'Townsend Security',
  'TP-LINK Technologies Co., Ltd',
  'TPV Technology LTD',
  'Trace3, Inc.',
  'Tracewell Systems, Inc.',
  'Track Core Inc',
  'TradeGear LLC',
  'tradeshow-stuff',
  'Traffic and Parking Control Company Inc',
  'Transcend Information, Inc.',
  'Transformational Security, LLC',
  'TreeAge Software, Inc.',
  'Trellix',
  'Trend Micro, Inc.',
  'TRENDnet Inc.',
  'TriCIS Ltd',
  'Trident Systems Inc.',
  'Triitus Corporation, Inc',
  'Trimble Inc',
  'Trimm, Inc.',
  'Trinity Dynamics, Inc',
  'Tripp Lite Power Protection',
  'Tri-State Camera',
  'Troxell Communications',
  'trueCABLE Inc.',
  'Trusted Systems, Inc.',
  'Trustwave Holdings Inc',
  'TRU-Vu Monitors, Inc.',
  'TSI Incorporated',
  'TTI, Inc.',
  'Turbonomic Inc',
  'Turn-key Technologies, Inc.',
  'TVAR Solutions LLC',
  'Twelve South LLC',
  'Ubiquiti Networks, Inc.',
  'UCL Swift NA',
  'Ugreen Group LTD',
  'UiPath Inc',
  'Uline Inc',
  'Ultimaker BV',
  'Ultra Electronics',
  'Ultralife Corp.',
  'UMPCO, Inc.',
  'Unassailable Solutions, LLC',
  'UniLook',
  'Unirise Electronics Co., LTD',
  'United Computer Products Co, Inc',
  'United Security Seals Inc',
  'United States Plastic Corporation',
  'Unitek',
  'Unitrends, Inc.',
  'Univa, Inc.',
  'Universal Switching Corp',
  'Unknown Company From Scan',
  'Uplift, Inc.',
  'Uplogix, Inc.',
  'Uptime Devices',
  'Urban Armor Gear, LLC',
  'US Patriot Tactical',
  'Uxcell',
  'VADCON Inc.',
  'VAE, Inc.',
  'Valmont Site Pro 1',
  'Valsoft Corporation',
  'VANCO International, Inc',
  'VanDyke Software, Inc.',
  'Vanguard LED Displays, Inc.',
  'Vari',
  'Variphy, Inc.',
  'Varonis Systems Inc.',
  'VAST Data, Inc.',
  'VCom Technology Solutions Group',
  'VCT Electronics',
  'Vectra AI, Inc.',
  'Veeam Software AG',
  'Velcro Industries B.V.',
  'Venafi, Inc.',
  'Ventura Technology Group, Inc.',
  'Veracity Group Inc.',
  'Veracode, Inc.',
  'Veritas Technologies LLC',
  'Verizon Communications Inc.',
  'VERSA NETWORKS',
  'Versa Products, Inc.',
  'Versalent',
  'Versitron, Inc.',
  'Vertex Wireless, LLC',
  'Vertical Cable',
  'Vertiv CO',
  'Vertosoft LLC',
  'Vesta Precision',
  'Veteran Information Technologies',
  'Veteran Technologies, Inc',
  'VFO Group',
  'VIA Technology, LLC',
  'ViaSat, Inc.',
  'Viavi Solutions Inc.',
  'Vic Myers Associates',
  'Victorinox AG',
  'Video Display Corp.',
  'Video Display Corporation',
  'ViewSonic Corp.',
  'Viewz Inc',
  'Villain Electronics',
  'Villain Electronics LLC',
  'Vinco, Inc.',
  'Vishay Intertechnology, Inc.',
  'Vision Engineering LTD',
  'Vision Research',
  'Visioneer, Inc.',
  'Visual Click Software, Inc.',
  'Visual Systems Group, Inc.',
  'VisualSVN LTD',
  'Vitec Group plc',
  'VIVO Technology',
  'Vizio, Inc.',
  'VMTurbo, Inc.',
  'VMware, Inc.',
  'Voice Products',
  'Voom Technologies, Inc.',
  'VTech Communications Inc.',
  'VuWall Technology Inc',
  'W.S. Darley & Co',
  'Wacom Technology Co.',
  'Wallco Industrial Electronics',
  'Wal-Mart Stores, Inc.',
  'Warehouse Cables, LLC',
  'Waters Network Systems LLC',
  'Wave Technologies, Inc.',
  'Wayfair',
  'Wayside Technology Group, Inc.',
  'Waytek Inc',
  'WBParts Inc.',
  'WBT LLC',
  'WDL Systems LLC',
  'WDM, Inc.',
  'WebstraurantStore',
  'WeConnex',
  'Weltron Winston International, Ltd.',
  'WepTac A.G.',
  'WESCO International, Inc.',
  'WestconGroup, Inc.',
  'Western Audio Visual',
  'Western Digital Corp.',
  'Westlake Corporation',
  'WESTWAY ELECTRIC SUPPLY',
  'WestWind Computer Products, Inc.',
  'WhatsUp Gold',
  'Whirlwind Music Distributors, Inc.',
  'Whitaker Brothers, Inc.',
  'Whitenton Industries, Inc.',
  'Wideband Systems, Inc.',
  'WiFiStand',
  'Wiha Werkzeuge GmbH',
  'Will-Burt Co.',
  'Williams Sound, LLC',
  'Wilson Electronics, Inc.',
  'Winchester Electronics, Corp.',
  'Windward Consulting Group, Inc.',
  'Windy City Wire Cable & Technology Products, LLC',
  'WinMagic Inc.',
  'Winsted Corp.',
  'Wintec Industries, Inc.',
  'WireCare',
  'Wirefy',
  'WiTopia',
  'WOFICLO',
  'Wohler Technologies, Inc.',
  'Wondershare Software Co., Ltd',
  'World Cord Sets, inc.',
  'World Wide Technology, LLC',
  'WorldViz',
  'WPS',
  'WyreStorm Technologies LLC',
  'X1 Discovery, Inc.',
  'XCRFID',
  'Xenarc Technologies Corp.',
  'Xerox Corp.',
  'Xilinx, Inc.',
  'XLTS.dev',
  'Xnaut',
  'Xplore Technologies Corp.',
  'Xpower',
  'XS International, Inc.',
  'Xytronix Research & Design, Inc.',
  'Yaesu USA',
  'Yamaha Corp.',
  'Yescom USA, Inc',
  'Yogasleep',
  'Yubico AB',
  'Yung Li',
  'Z3 Technology',
  'ZAGG Intellectual Property Holding Co., Inc.',
  'Z-Band Technologies, LLC.',
  'ZeceTech LLC',
  'Zendesk, Inc.',
  'Zero Connect',
  'ZeroDay Technology Solutions',
  'Zerto LTD',
  'Zhangzhou Lilliput Electronic Co., Ltd',
  'Zhongshan Asteroids Electronics Co., Ltd',
  'Zhongshan Xiaoxiang Electronic Technology Co. LTD',
  'Zhongshan Yifan Electronic Technology Co. LTD',
  'ZIH Corp.',
  'Zivaro Inc.',
  'ZLiT',
  'ZOHO Corp.',
  'Zones.com',
  'Zonit Structured Solutions Systems, LLC',
  'Zoom Video Communications, Inc.',
  'Zoro Tools Inc',
  'ZSA Technology',
  'ZTHY TECH',
  'ZYLTECH ENGINEERING, LLC',
]
